/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import React, { useState, useRef, useLayoutEffect } from 'react'
import {
Text,
View,
Alert,
ScrollView,
SafeAreaView,
Vibration} from 'react-native';
import styles from './styles';
import { PreferenceCard } from '../../components';
import {
Firestore,
getAuth,
reauthenticateWithCredential,
updateEmail,
updatePassword,
deleteUser,
EmailAuthProvider
} from '../../firebase/config';
import { Icon, ListItem, Input, Button} from 'react-native-elements';


export default function PreferencesScreen(props) {
const key = props.route.params.key;
const user = props.extraData.user;
const [displayName, setDisplayName] = useState('');
const [emailAddress, setEmailAddress] = useState('');
const [confirmEmailAddress, setConfirmEmailAddress] = useState('');
const [currentPassword, setCurrentPassword] = useState('');
const [password, setPassword] = useState('');
const [confirmPassword, setConfirmPassword] = useState('');
const [secureText, setSecureText] = useState(true);
const [secureIcon, setSecureIcon] = useState('eye-off');
const [errorMessage, setErrorMessage] = useState('');
const [authenticatedComponent, setAuthenticatedComponent] = useState(false);
const currentPasswordInput = useRef();
const newPasswordInput = useRef();
const confirmNewPasswordInput = useRef();
const emailAddressInput = useRef();
const confirmEmailAddressInput = useRef();
const displayNameInput = useRef();
const auth = getAuth();
const { navigation } = props;
const userRef = Firestore.collection('users').doc(user.id);


//Display Name Component
const displayNameComponent = () => {
useLayoutEffect(() => {
navigation.setOptions({
title: 'Display Name'
});
},[])
return (
<PreferenceCard>
<View style={styles.headerContainer}>
<Icon
 name={'face'}
 size={90}
 />
<Text style={styles.headerTitle}>Edit Display Name</Text>
<Text style={styles.headerSubtitle}>Enter New Display Name</Text>
</View>
<View style={styles.actionContainer}>
<Input
 containerStyle={styles.actionInput}
 ref={displayNameInput}
 placeholder={user.fullName}
 leftIcon={{name: 'person'}}
 onChangeText={(text) => setDisplayName(text)}
 textContentType={'name'}
 autoComplete={'name'}
 />
 <Button
 buttonStyle={styles.button}
  title="Save"
  onPress={() => {
  onDisplayNameUpdate()
  }}
  />
 </View>
</PreferenceCard>
)
}


//Delete User Component
const deleteUserComponent = () => {
useLayoutEffect(() => {
navigation.setOptions({
title: 'Delete User Data'
});
},[])
return (
<SafeAreaView style={styles.containerCol}>
<View style={styles.headerContainer}>
<Icon
 name={'delete-forever'}
 size={90}
 color={'red'}
 />
<Text style={styles.headerTitle}>Delete User Data</Text>
<Text style={styles.headerSubtitle}>All data associated with your user account along with your log-in credentials will be deleted!</Text>
</View>
<View style={styles.actionContainer}>
<Button
 title={'Delete My Data'}
 buttonStyle={{backgroundColor: 'red', margin: 10}}
 onPress={() => {requestUserDeletion();}}/>
<Button
 title={'Cancel'}
 buttonStyle={{backgroundColor: 'black', margin: 10}}
 onPress={() => {
 setAuthenticatedComponent(false);
 navigation.goBack();
 }}
 />
</View>
</SafeAreaView>
)
}

//Toggles secure text fields
const toggleSecureText = () => {
setSecureText(!secureText);
setSecureIcon(
secureIcon === "eye-off"
? "eye"
: "eye-off"
);
}


//Re-Authentication Component
const reAuthenticateComponent = () => {
useLayoutEffect(() => {
navigation.setOptions({
title: 'Authentication Required'
});
},[])
return (
<PreferenceCard>
<Icon
 name={'lock'}
 size={90}
 />
<Text style={styles.headerTitle}>Authentication Required</Text>
<Text style={styles.headerSubtitle}>Please enter your current password to continue</Text>
<Input
containerStyle={styles.actionInput}
ref={currentPasswordInput}
secureTextEntry={secureText}
placeholder="Enter Current Password"
leftIcon={{name: 'lock'}}
rightIcon={{type: 'feather', name: secureIcon, onPress: () => {toggleSecureText();}}}
errorStyle={{color: 'red'}}
errorMessage={errorMessage}
onChangeText={(text) => {setCurrentPassword(text)}}
textContentType={'password'}
autoComplete={'password'}
/>
<Button
buttonStyle={styles.button}
title="Submit"
onPress={() => {
currentPasswordInput.current.clear();
reAuthDirect();
}}
/>
</PreferenceCard>
)
}

//Email Address Component
const emailAddressComponent = () => {
useLayoutEffect(() => {
navigation.setOptions({
title: 'Email Address'
});
},[])
return (
<PreferenceCard>
<View style={styles.headerContainer}>
<Icon
 name={'mail'}
 size={90}
 />
<Text style={styles.headerTitle}>Update Email Address</Text>
<Text style={styles.headerSubtitle}>Enter New Email Address</Text>
</View>
<Input
 containerStyle={styles.actionInput}
 secureTextEntry={false}
 ref={emailAddressInput}
 placeholder="Email Address"
 leftIcon={{name: 'mail'}}
 errorStyle={{color: 'red'}}
 errorMessage={errorMessage}
 onChangeText={(text) => {setEmailAddress(text)}}
 textContentType={'emailAddress'}
 autoComplete={'email'}
 />
<Input
 containerStyle={styles.actionInput}
 ref={confirmEmailAddressInput}
 placeholder="Confirm Email Address"
 leftIcon={{name: 'mail'}}
 errorStyle={{color: 'red'}}
 errorMessage={errorMessage}
 onChangeText={(text) => {setConfirmEmailAddress(text)}}
 textContentType={'emailAddress'}
 autoComplete={'email'}
 autoCapitalize={'none'}
 />
 <Button
 buttonStyle={styles.button}
  title="Save"
  onPress={() => {onEmailUpdate();}}
  />
</PreferenceCard>
)
}

//New Password Component
const newPasswordComponent = () => {
useLayoutEffect(() => {
navigation.setOptions({
title: 'Update Password'
});
},[])
return (
<PreferenceCard>
<View style={styles.headerContainer}>
<Icon
 name={'lock'}
 size={90}
 />
<Text style={styles.headerTitle}>Update Password</Text>
<Text style={styles.headerSubtitle}>Enter New Password</Text>
</View>
<View style={styles.actionContainer}>
<Input
 containerStyle={styles.actionInput}
 ref={newPasswordInput}
 secureTextEntry={secureText}
 placeholder="New Password"
 leftIcon={{name: 'lock'}}
 rightIcon={{type: 'feather', name: secureIcon, onPress: () => {toggleSecureText();}}}
 errorStyle={{color: 'red'}}
 errorMessage={errorMessage}
 renderErrorMessage={false}
 onChangeText={(text) => {setPassword(text)}}
 textContentType={'newPassword'}
 autoComplete={'password-new'}
 />
<Input
 containerStyle={styles.actionInput}
 ref={confirmNewPasswordInput}
 secureTextEntry={secureText}
 placeholder="Confirm New Password"
 leftIcon={{name: 'lock'}}
 rightIcon={{type: 'feather', name: secureIcon, onPress: () => {toggleSecureText();}}}
 errorStyle={{color: 'red'}}
 errorMessage={errorMessage}
 onChangeText={(text) => {setConfirmPassword(text)}}
 textContentType={'password'}
 autoComplete={'password'}
 />
 <Button
 buttonStyle={styles.button}
  title="Save"
  onPress={() => {onPasswordUpdate()}}
  />
 </View>
</PreferenceCard>
)
}

const legalComponent = () => {
useLayoutEffect(() => {
navigation.setOptions({
title: 'Legal'
});
},[])
return (
<SafeAreaView style={{flex: 1, backgroundColor: 'white'}}>
<ScrollView>
    <ListItem
    containerStyle={styles.listItem}
    onPress={() => {navigation.navigate('Legal', {document: 'terms'})}}
    bottomDivider={true}>
    <Icon
    name={'description'}
    size={30}
    />
      <ListItem.Content>
        <ListItem.Title><Text style={styles.titleText}>Terms & Conditions</Text></ListItem.Title>
        <View style={styles.subtitleView}>
          <Text style={styles.subtitleText}>View Our Terms & Conditions</Text>
        </View>
      </ListItem.Content>
      <ListItem.Chevron
       size={30}
       />
    </ListItem>
    <ListItem
    containerStyle={styles.listItem}
    onPress={() => {navigation.navigate('Legal', {document: 'privacy'})}}
    bottomDivider={true}>
    <Icon
    name={'policy'}
    size={30}
    />
      <ListItem.Content>
        <ListItem.Title><Text style={styles.titleText}>Privacy Policy</Text></ListItem.Title>
        <View style={styles.subtitleView}>
          <Text style={styles.subtitleText}>View Our Privacy Policy</Text>
        </View>
      </ListItem.Content>
      <ListItem.Chevron
       size={30}
       />
    </ListItem>
<ListItem
    containerStyle={styles.listItem}
    onPress={() => {navigation.navigate('Legal', {document: 'attribution'})}}
    bottomDivider={true}>
    <Icon
    name={'groups'}
    size={30}
    />
      <ListItem.Content>
        <ListItem.Title><Text style={styles.titleText}>Acknowledgements</Text></ListItem.Title>
        <View style={styles.subtitleView}>
          <Text style={styles.subtitleText}>Open Source Licenses</Text>
        </View>
      </ListItem.Content>
      <ListItem.Chevron
       size={30}
       />
    </ListItem>
 </ScrollView>
</SafeAreaView>
)
}


//On Password Update
const onPasswordUpdate = () => {
setErrorMessage(null);
if (!(password === confirmPassword)) {
setErrorMessage('Passwords Do Not Match');
return;
}
const user = auth.currentUser;
return updatePassword(user, password).then(() => {
//Display toast stating password has been updated?
setAuthenticatedComponent(false);
//newPasswordInput.current.clear();
//confirmNewPasswordInput.current.clear();
navigation.goBack();
}).catch((err) => {
console.error(`Error updating password: ${err}`);
});
};

//On Email Update
const onEmailUpdate = () => {
setErrorMessage(null);
if (!(emailAddress === confirmEmailAddress)) {
setErrorMessage('Email Addresses Do Not Match');
return;
}
const user = auth.currentUser;
return updateEmail(user, emailAddress).then(() => {
userRef.update({
email: emailAddress
}).then(() => {
setAuthenticatedComponent(false);
//emailAddressInput.current.clear();
//confirmEmailAddressInput.current.clear();
navigation.goBack();
}).catch((err) => {
console.error("Error updating email address on user profile", err);
navigation.goBack();
});
}).catch((err) => {
console.error("Auth Error updating email address", err);
switch (err.code) {
case 'auth/email-already-in-use':
setErrorMessage('Email Address Already in Use');
break;
}
});
}

//On Display Name Update
const onDisplayNameUpdate = () => {
const task = userRef.update({
fullName: displayName
}).then(() => {
displayNameInput.current.clear();
navigation.goBack();
}).catch((err) => {
console.error("Error updating display name", err);
navigation.goBack();
})
return () => task();
}

const requestUserDeletion = async () => {
if (Platform.OS === 'web') {
if (confirm("Delete User Account? This action cannot be undone. Do you wish to proceed?") === true) {
}}
else {
Vibration.vibrate()
Alert.alert(
"Delete User Data?",
"This action cannot be undone.",
[
{
text: "Delete My Data",
onPress: () => deleteUserData(),
style: "destructive",
},
{
text: "Cancel",
style: "cancel",
},
],
{
cancelable: true,
}
);
}
}

//Deletes User Data after Successful Re-Auth
const deleteUserData = () => {
 const user = auth.currentUser;
 return deleteUser(user).then(() => {
 setAuthenticatedComponent(false);
 }).catch((err) => {
 console.error("Error deleting user data", err);
 });
 };


//Handles the Re-Auth request and then shows the next component.
const reAuthDirect = () => {
return reAuthenticate().then(() => {
setErrorMessage(null);
setAuthenticatedComponent(true);
}).catch((err) => {
console.error("Error Re-Authenticating User", err);
switch(err.code) {
case "auth/too-many-requests":
setErrorMessage("Too Many Requests, Please Try Again Later");
alert("Too Many Requests, Please Try Again Later");
break;
case "auth/wrong-password":
setErrorMessage("Incorrect Password");
break;
}
});
};

//Re-Authenticates user with Firebase Auth
const reAuthenticate = () => {
const user = auth.currentUser;
var cred = EmailAuthProvider.credential(user.email, currentPassword);
return reauthenticateWithCredential(user, cred);
}

if (authenticatedComponent) {
switch (key) {
case 'emailAddress':
return emailAddressComponent();
case 'password':
return newPasswordComponent();
case 'deleteUser':
return deleteUserComponent();
}}


//Handles UI given with different mode options
//This is required to return something from render.
switch (key) {
case 'displayName':
return displayNameComponent();
case 'emailAddress':
return reAuthenticateComponent();
case 'password':
return reAuthenticateComponent();
case 'deleteUser':
return reAuthenticateComponent();
case 'legal':
return legalComponent();
}
}